import { createSlice } from '@reduxjs/toolkit';
import api from '../Components/_helpers/api';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    signService: {
      isLoading: true,
      isAvailable: true,
      error: '',
    },
    mhRecepcionService: {
      isLoading: true,
      isAvailable: true,
      error: '',
    },
  },
  reducers: {
    requestSignServiceHandshake: (state, action) => {
      state.signService = { isLoading: true, isAvailable: true, error: '' };
    },
    requestSignServiceHandshakeSuccess: (state, action) => {
      state.signService = { isLoading: false, isAvailable: true, error: '' };
    },
    requestSignServiceHandshakeFailure: (state, action) => {
      state.signService = { isLoading: false, isAvailable: false, error: action.payload };
    },
    setSignServiceError: (state, action) => {
      state.signService = { isLoading: false, isAvailable: false, error: action.payload };
    },
    requestMHRecepcionServiceHandshake: (state, action) => {
        state.mhRecepcionService = { isLoading: true, isAvailable: true, error: action.payload };
    },
    requestMHRecepcionServiceHandshakeSuccess: (state, action) => {
        state.mhRecepcionService = { isLoading: false, isAvailable: true, error: action.payload };
    },
    requestMHRecepcionServiceHandshakeFailure: (state, action) => {
        state.mhRecepcionService = { isLoading: false, isAvailable: false, error: action.payload };
    },
    setMHRecepcionServiceError: (state, action) => {
        state.mhRecepcionService = { isLoading: false, isAvailable: false, error: action.payload };
    },
  },
});

export const {
  requestSignServiceHandshake,
  requestSignServiceHandshakeSuccess,
  requestSignServiceHandshakeFailure,
  setSignServiceError,
  requestMHRecepcionServiceHandshake,
  requestMHRecepcionServiceHandshakeSuccess,
  requestMHRecepcionServiceHandshakeFailure,
  setMHRecepcionServiceError,
} = appSlice.actions;

//Thunks
export const requestSignServiceHandshakeAsync = (payload) => (dispatch) => {
    payload = payload || window.location.host;
  dispatch(requestSignServiceHandshake(payload));

  api
    .get(`/App/SignService/handshake?message=${window.location.host}`, payload)
    .then((data) => {
      dispatch(requestSignServiceHandshakeSuccess(data.data));
    })
    .catch((e) => {
      console.log(e);
      dispatch(requestSignServiceHandshakeFailure('Servicio de firmado no disponible.'));
    });
};

export const requestMHRecepcionServiceHandshakeAsync = (payload) => (dispatch) => {
    payload = payload || window.location.host;
  dispatch(requestMHRecepcionServiceHandshake(payload));

  api
    .get(`/App/MHRecepcionService/handshake?message=${window.location.host}`, payload)
    .then((data) => {
      dispatch(requestMHRecepcionServiceHandshakeSuccess(data.data));
    })
    .catch((e) => {
      console.log(e);
      dispatch(requestMHRecepcionServiceHandshakeFailure('Servicio del Ministerio de Hacienda no disponible.'));
    });
};

//Selector
export const selectSignService = (state) => state.app.signService;
export const selectMHRecepcionService = (state) => state.app.mhRecepcionService;

export default appSlice.reducer;
